import {
  MultiPicklistQuestion,
} from 'Views/FreemiumEntry/HasRelationship/Content/Templates/MultiPicklistQuestion';
import { InsightUpgrade } from 'Views/FreemiumEntry/HasRelationship/Content/Templates/InsightUpgrade';
import {
  InsightRequestConfirmation,
} from 'Views/FreemiumEntry/HasRelationship/Content/Templates/InsightRequestConfirmation';
import {
  StandardEQFFQResponseCompleted,
} from './StandardEQFFQResponseCompleted';
import { PicklistQuestion } from './PicklistQuestion';
import { Insight } from './Insight';
import { InsightAnalysis } from './InsightAnalysis';
import { InsightIntro } from './InsightIntro';
import { InsightProduct } from './InsightProduct';
import { InsightAction } from './InsightAction';
import { ContactInformation } from './ContactInformation';
import { InfluencerContactInformation } from './InfluencerContactInformation';
import { PaymentPage } from './PaymentPage';
import { FoundationsPaymentCompleted } from './FoundationsPaymentCompleted';
import { InsightSocialProof } from './InsightSocialProof';
import { InsightSchedule } from './InsightSchedule';
import { InsightInfluencer } from './InsightInfluencer';

const templateMap = {
  FQResponsePicklistQuestion: PicklistQuestion,
  FQResponseMultiPicklistQuestion: MultiPicklistQuestion,
  FQResponseInsight: Insight,
  FQResponseInsightUpgrade: InsightUpgrade,
  FQResponseInsightAnalysis: InsightAnalysis,
  FQResponseInsightIntro: InsightIntro,
  FQResponseInsightProduct: InsightProduct,
  FQResponseInsightRequestConfirmation: InsightRequestConfirmation,
  FQResponseInsightUpgradeEmpty: InsightRequestConfirmation,
  FQResponseInsightSocialProof: InsightSocialProof,
  FQResponseInsightAction: InsightAction,
  FQResponseInsightSchedule: InsightSchedule,
  FQResponseInsightInfluencer: InsightInfluencer,
  FQResponseInsightReferralIntro: InsightSocialProof,
  FQResponseContactInformation: ContactInformation,
  FQResponseContactAndQualificationInformation: ContactInformation,
  FQResponseContactAndQualificationInformationReferee: ContactInformation,
  FQResponseContactAndInfluencerInformation: InfluencerContactInformation,
  FQResponsePaymentPage: PaymentPage,
  StandardEQFFQResponseCompleted,
  FoundationsPaymentCompleted,
};

export const getTemplate = (resourceType) => {
  const template = templateMap[resourceType];

  if (!template) {
    throw new Error(`Developer config error: Unhandled source type ${resourceType}`);
  }

  return template;
};
